<template>
  <div :class="className" class="paging">
    <el-pagination
      background
      :hide-on-single-page="true"
      :current-page.sync="childPage"
      @current-change="changePage"
      layout="prev, pager, next, total, jumper"
      :page-size="limit"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: 'base-paging'
    },
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    limit: {
      type: Number,
      default: 10
    }
  },
  // watch: {
  //   page (newal, oldal) {
  //     // 请求数据
  //     this.childPage = newal
  //     console.log(newal)
  //     console.log(this.childPage)
  //     // this.page = newal
  //     // this.$store.commit('undateSpeciesPage', newal)
  //     // this.getData()
  //   }
  // },
  data () {
    return {
      childPage: this.page
    }
  },
  methods: {
    changePage (val) {
      this.$emit('update:page', val)
    }
  }
}
</script>

<style scoped lang="scss">
.paging {
  overflow: hidden;
  display: inline-block;
}
.base-paging
  >>> .el-pagination.is-background
  .el-pager
  li:not(.disabled):hover {
  color: $theme_color;
}
.base-paging >>> .el-input.is-active .el-input__inner,
.base-paging >>> .el-input__inner:focus {
  border-color: $theme_color;
}
.base-paging
  >>> .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  /* background: #135ea4; */
  background: $theme_color;
  color: #fff;
}
.paging >>> .el-input__inner {
  background: transparent;
}
.paging >>> .el-pagination__jump {
  margin: 0;
}
.paging >>> .el-pagination.is-background .btn-next,
.paging >>> .el-pagination.is-background .btn-prev,
.paging >>> .el-pagination.is-background .el-pager li {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/paging.vue